<template>
  <b-container>
    <div :class="{
        'fixed-header': !isHeaderHidden,
        'hidden-header': isHeaderHidden,
        'show-header': showHeader,
      }">
      <b-container class="header-container">
        <div class="header-left">
          <span @click="scrollToSection('mainBanner')" class="logo-link" :class="{ 'logo-link-menu-open': isMobileMenuOpen }">Grexy</span>
          <language-switcher></language-switcher>
        </div>
        <div v-if="isMobile" class="hamburger-menu" @click="toggleMobileMenu" :class="{ 'hamburger-menu-open': isMobileMenuOpen }">
          <div class="bar bar-1"></div>
          <div class="bar bar-2"></div>
          <div class="bar bar-3"></div>
        </div>
        <div v-if="isMobile" class="mobile-menu" :class="{ 'mobile-menu-open': isMobileMenuOpen }">
          <b-nav class="nav-header-container">
            <b-nav-item @click="scrollToSection('mainBanner')">{{ $t('About Grexy') }}</b-nav-item>
            <b-nav-item v-b-toggle.collapse-a.collapse-b.collapse-c>{{$t( 'how_grexy_works')}}</b-nav-item>
            <b-collapse id="collapse-a">
              <b-nav-item to="/about">{{ $t('user_information') }}</b-nav-item>
            </b-collapse>
            <b-collapse id="collapse-b">
              <b-nav-item to="/user-info">{{ $t('worth_knowing') }}</b-nav-item>
            </b-collapse>
            <b-collapse id="collapse-b">
              <b-nav-item to="/news">{{ $t('news') }}</b-nav-item>
            </b-collapse>
            <b-collapse id="collapse-c">
              <b-nav-item to="/messenger">{{ $t('messenger') }}</b-nav-item>
            </b-collapse>
            <b-nav-item to="/team">{{ $t('team') }}</b-nav-item>
          </b-nav>
        </div>
        <b-nav v-else class="nav-header-container">
          <b-nav-item @click="scrollToSection('mainBanner')">{{ $t('About Grexy') }}</b-nav-item>
          <b-nav-item-dropdown  :text="$t( 'how_grexy_works')" class="dropdown-main-nav">
            <b-nav-item to="/about">{{ $t('user_information') }}</b-nav-item>
            <b-nav-item to="/user-info">{{ $t('worth_knowing') }}</b-nav-item>
            <b-nav-item to="/news">{{ $t('news') }}</b-nav-item>
            <b-nav-item to="/messenger">{{ $t('messenger') }}</b-nav-item>
          </b-nav-item-dropdown>
          <b-nav-item to="/team">{{ $t('team') }}</b-nav-item>
        </b-nav>
      </b-container>
    </div>
  </b-container>
</template>

<script>
import LanguageSwitcher from '@/components/LanguageSwitcher'
export default {
  components: {
    LanguageSwitcher
  },
  data () {
    return {
      selectedLanguage: 'en',
      isHeaderHidden: false,
      prevScrollPos: 0,
      showHeader: false,
      isMobile: false,
      isMobileMenuOpen: false
    }
  },
  watch: {
    $route (to, from) {
      this.isMobileMenuOpen = false
    },
    isMobileMenuOpen (newValue) {
      if (newValue) {
        document.body.classList.add('no-scroll')
      } else {
        document.body.classList.remove('no-scroll')
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    this.isMobile = this.$isMobile()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      const currentScrollPos = window.pageYOffset
      if (currentScrollPos > this.prevScrollPos) {
        this.isHeaderHidden = true
      } else {
        this.isHeaderHidden = false
      }
      this.prevScrollPos = currentScrollPos
      if (currentScrollPos < 30) {
        this.showHeader = false
      } else {
        this.showHeader = true
      }
    },
    toggleMobileMenu () {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    async scrollToSection (sectionId) {
      if (this.$route.path !== '/') {
        try {
          await this.$router.push('/')
          this.$nextTick(() => {
            this.scrollTo(sectionId)
          })
        } catch (err) {
          console.error(err)
        }
      } else {
        this.$nextTick(() => {
          this.scrollTo(sectionId)
        })
      }
    },
    scrollTo (sectionId) {
      const targetElement = document.getElementById(sectionId)
      if (targetElement) {
        const yOffset = -80
        const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  transition: transform 0.3s ease;
}
.show-header{
  background: radial-gradient(66.25% 121.93% at 70.64% -15.07%, #8184F9 12.26%, #5C5EE8 91.15%);
  .header-container{
    .nav-header-container{
      .nav-link{
        color: #ffffff;
      }
      .dropdown-main-nav{
        a{
          color: #ffffff;
        }
      }
    }
  }
  .header-container .header-left .logo-link{
    color: #ffffff;
  }
  .switcher-lang{
    background: #FEDB5D;
  }
  .hamburger-menu{
    background: rgba(255, 255, 255, 0.20);
    .bar {
      background-color: #ffffff;
    }
  }
}
.hidden-header {
  height: 0;
  transform: translateY(-100%);
}
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (min-width: 320px) {
    padding: 20px 15px;
  }
  @media screen and (min-width: 992px) {
    padding: 20px 0;
  }
  .header-left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .logo-link{
      color: #7A7CE8;
      font-family: $main-font;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      transition: color 0.3s ease;
      cursor: pointer;
      &:hover{
        text-decoration: none;
      }
      @media screen and (min-width: 320px) {
        font-size: 32px;
        margin-right: 16px;
      }
      @media screen and (min-width: 768px) {

      }
      @media screen and (min-width: 992px) {

      }
      @media screen and (min-width: 1440px) {
        font-size: 40px;
        margin-right: 24px;
      }
      @media screen and (min-width: 1920px) {
        font-size: 40px;
        margin-right: 24px;
      }
    }
    .logo-link-menu-open {
      z-index: 9999;
      color: #7A7CE8;
    }
  }
  .nav-header-container{
    align-items: center;
    gap: 24px;
    @media screen and (min-width: 320px) {
      gap: 24px;
    }
    @media screen and (min-width: 768px) {
      gap: 5px;
    }
    @media screen and (min-width: 992px) {
      gap: 24px;
    }
    @media screen and (min-width: 1440px) {

    }
    .nav-link{
      color: #232333;
      font-family: $main-font;
      font-style: normal;
      font-weight: 600;
      line-height: 140%; /* 25.2px */
      padding: 0;
      white-space: nowrap;
      @media screen and (min-width: 320px) {
        font-size: 16px;
      }
      @media screen and (min-width: 768px) {

      }
      @media screen and (min-width: 992px) {

      }
      @media screen and (min-width: 1440px) {
        font-size: 18px;
      }
      @media screen and (min-width: 1920px) {
        font-size: 18px;
      }
    }
    .nav-item.btn-app{
      padding: 9px 16px;
      border-radius: 16px;
      background: rgba(255, 255, 255, 0.20);
    }
  }
}
/*** Mobile ***/
.hamburger-menu {
  border-radius: 16px;
  background: rgba(122, 124, 232, 0.1);
  width: 40px;
  height: 40px;
  padding: 0px 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 9999;

  .bar {
    width: 100%;
    height: 3px;
    background-color: rgba(48, 57, 75, 1);
    transition: 0.4s;

    &.bar-1 {
      transform: translateY(-3px) rotate(0deg);
    }
    &.bar-2 {
      transform: translateY(0px) rotate(0deg);
    }
    &.bar-3 {
      transform: translateY(3px) rotate(0deg);
    }
  }
  &.hamburger-menu-open {
    .bar-1 {
      background-color: #30394B;
      transform: translateY(3px) rotate(45deg);
    }
    .bar-2 {
      opacity: 0; /* Зникає */
    }
    .bar-3 {
      background-color: #30394B;
      transform: translateY(-3px) rotate(-45deg);
    }
  }
}

.mobile-menu {
  position: absolute;
  top: 0;
  right: 0;
  width: 120%;
  height: 58vh;
  max-height: 0;
  overflow: hidden;
  padding: 15px 16px;
  background-color: #fff;
  z-index: 1;
  opacity: 0;
  transition: max-height 0.3s ease, opacity 0.3s ease;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  border-bottom-left-radius: 87%;
  .nav-header-container{
    display: none;
  }
}

.mobile-menu-open {
  max-height: 58vh;
  opacity: 1;
  .nav-header-container{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: end;
    margin-top: 75px;
    gap: 16px;
    .nav-item{
      .nav-link{
        color: #30394B;
        font-family: $main-font;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        white-space: nowrap;
      }
    }
    .nav-item.btn-app{
      display: flex;
      padding: 8px 16px;
      justify-content: center;
      align-items: center;
      gap: 7px;
      border-radius: 16px;
      background: #F7EDFD;
    }
  }
}
</style>
